module.exports = __webpack_public_path__ + "img/red-diamond.c2fbf886.png";